import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchFlowDeletionImpact = (flowId, options = {}) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();

  const {
    isLoading, isError, isSuccess, data,
  } = useQuery(
    ['flow-deletion-impact', orgId, flowId],
    async () => axiosInstance.get(flow(orgId).deletionImpact(flowId)),
    {
      enabled: !!flowId,
      onError: (error) => dispatch(showAlert({
        message: error.response?.data?.message || 'Failed to fetch deletion impact',
        type: 'error',
      })),
      retry: false,
      refetchOnWindowFocus: false,
      ...options,
    },
  );

  return {
    isLoading, isError, isSuccess, data: data?.data,
  };
};
